import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogOutIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14.7 14.7",
	style: { enableBackground: "new 0 0 14.7 14.7" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.log-out-icon-st0{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "log-out-icon-st0",
			d: "M10.9,4l3.3,3.3l-3.3,3.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "log-out-icon-st0",
			d: "M5.4,7.3h8.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "log-out-icon-st0",
			d: "M5.4,14.2H1.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4V1.1c0-0.2,0.1-0.3,0.2-0.4 C0.8,0.6,1,0.5,1.1,0.5h4.4"
		})
	] }) }) })]
});
export default SvgLogOutIcon;
